// 单独清关 같은 营业执照 화주 자동 합치기 계획(2026-10-08 YZY) — 순수 함수(import 없음, 단위 테스트: __tests__/ownerAutoMerge.test.mjs)
//
// 규칙(YZY 16:09): ① 대표 화주 = 그 营业执照의 주인(收件信息의 수령인이 속한 화주) ② 单独清关 만(호출하는 쪽이 综合 는 안 부른다)
// ③ 합친 뒤 해제 가능 — 해제한 营业执照는 off 에 넣어 다시 자동으로 합치지 않는다. 직원이 손으로 합친 화주(manual)는 우선이라 건드리지 않는다.
// 합치기 상태는 #1205 의 ownerMerge(원래 화주 → 대표 화주) 와 같은 모양으로 돌려준다.

const key = v => String(v || '').replace(/\s/g, '').toLowerCase()

/**
 * @param {Array<{co:string, licenseId:string, licenseCo:string}>} owners  원래 화주(L열)마다 매칭된 营业执照 (licenseCo = 그 장이 등록된 화주)
 * @param {Object<string,string>} manual  직원이 손으로 합친 상태 { 원래 화주: 대표 화주 }
 * @param {Object<string,boolean>} off    해제한 营业执照 id
 * @returns {{ merge: Object<string,string>, lic: Object<string,string> }}  merge = { 합쳐질 화주: 대표 화주 }, lic = { 대표 화주: 营业执照 id }
 */
export function planAutoMerge(owners, manual, off) {
  const man = manual || {}
  const skip = new Set(Object.keys(man).concat(Object.values(man)))
  const byLic = new Map()
  for (const o of owners || []) {
    if (!o || !o.co || !o.licenseId || skip.has(o.co) || (off && off[o.licenseId])) continue
    if (!byLic.has(o.licenseId)) byLic.set(o.licenseId, [])
    byLic.get(o.licenseId).push(o)
  }
  const merge = {}
  const lic = {}
  for (const [id, list] of byLic) {
    if (list.length < 2) continue
    const sorted = list.slice().sort((a, b) => a.co.localeCompare(b.co))
    const rep = (sorted.find(o => key(o.licenseCo) && key(o.licenseCo) === key(o.co)) || sorted[0]).co
    sorted.forEach(o => { if (o.co !== rep) merge[o.co] = rep })
    lic[rep] = id
  }
  return { merge, lic }
}
